import React, { createContext, useContext, ReactNode } from "react";
import { useCourseManagement } from "@root/hooks/useCourseManagement";

const defaultState: any = {};

const CourseManagementContext = createContext<any>(defaultState);

interface CourseManagementProviderProps {
  children: ReactNode;
}

export const CourseManagementProvider: React.FC<
  CourseManagementProviderProps
> = ({ children }) => {
  const data = useCourseManagement();
  return (
    <CourseManagementContext.Provider value={data}>
      {children}
    </CourseManagementContext.Provider>
  );
};

export const useCourseManagementContext = () => {
  return useContext(CourseManagementContext);
};
